import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import {
    useGetOutlookCredentialsQuery,
    useUploadCashCreditFileCompareMutation
} from '../../../../store/google-reservations/googleReservationsApi';
import { useGetCurrentAuthUrlQuery } from '../../../../store/reservations/reservationsApi';
import DiscrepancyModal from './DiscrepancyModal';
import Button from '../../../../shared/button';
import Modal from '../../../../shared/modal';
import Error from '../../../../shared/error';


interface IUploadFilesModal {
    openModal: boolean;
    type: string;
    handleCloseModal: () => void;
}

const UploadFilesModal = ({
    openModal,
    type,
    handleCloseModal
}: IUploadFilesModal) => {
    const { data: authUrl } = useGetCurrentAuthUrlQuery({});
    const { data: outlookCredentials } = useGetOutlookCredentialsQuery();
    const [uploadCashCreditFileCompare, { isLoading, data, error }] = useUploadCashCreditFileCompareMutation()
    const [firstFile, setFirstFile] = useState<any>();
    const [secondFile, setSecondFile] = useState<any>();
    const [thirdFile, setThirdFile] = useState<any>();
    const [response, setResponse] = useState<any>();
    const [generalError, setGeneralError] = useState<string>();
    const [submitLoading, setSubmitLoading] = useState<boolean>(false)

    const onDrop = useCallback((acceptedFiles: any) => {
        setFirstFile(acceptedFiles?.[0]);
    }, []);

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
    });

    const { getRootProps: getRootPropsActive, getInputProps: getInputPropsActive } = useDropzone({
        onDrop: (acceptedFile) => {
            setSecondFile(acceptedFile[0]);
        },
    });

    const { getRootProps: getRootPropsOpera, getInputProps: getInputPropsOpera } = useDropzone({
        onDrop: (acceptedFile) => {
            setThirdFile(acceptedFile[0]);
        },
    });

    const onSubmit = async () => {
        if (submitLoading) {
            return;
        }
        setSubmitLoading(true)
        setGeneralError(undefined)
        const formData = new FormData()

        if (firstFile) {
            formData.append('creditCard', firstFile)
        }
        if (secondFile) {
            formData.append('bankTransaction', secondFile)
        }
        if (thirdFile) {
            formData.append('opera', thirdFile)
        }
        try {
            const { accessToken, refreshToken } = outlookCredentials || {};
            localStorage.setItem("googleAccessToken", accessToken || "");
            localStorage.setItem("googleRefreshToken", refreshToken || "");
            formData.append('accessToken', `${accessToken}`)
            if (accessToken) {
                const res = await uploadCashCreditFileCompare(formData).unwrap();
                setResponse(res?.data)
                // onCloseModal()
                setFirstFile(undefined)
                setGeneralError(undefined)
                setThirdFile(undefined)
                setSecondFile(undefined)
            } else {
                window.location.assign(authUrl.authUrl);
            }
        } catch (error) {
            setGeneralError(`${error}`)
        }
        setSubmitLoading(false)
    };

    const onCloseModal = () => {
        setFirstFile(undefined)
        setSecondFile(undefined)
        setThirdFile(undefined)
        setGeneralError(undefined)
        setResponse(undefined)
        setSubmitLoading(false)
        handleCloseModal()
    }

    return (
        <Modal
            open={openModal}
            showInRight={true}
            contentContainerStyle='!min-w-[100vw] md:!min-w-[650px]'
            onClose={onCloseModal}>
            <div className={'p-2 !min-w-[90vw] md:!min-w-[600px] md:!max-w-[600px]'}>
                <p className='mt-2 mb-4 page-title !text-[18px] font-bold mr-10'>Files to Compare</p>
                <div className='bg-[#e4ede657] rounded p-2 mb-2'>
                    <div>
                        <div
                            className='flex flex-row items-center'
                            {...getRootProps()}
                        >
                            <input {...getInputProps()} />
                            <Button
                                icon={<img src='/assets/shared/add-plus.svg' className='w-[30px] object-contains pr-2' />}
                                className={'btn-main !bg-white !py-2 !pr-3 !shadow-none !border-none flex flex-row items-center min-w-[250px]'}
                                label={`Select ${type === 'cash' ? 'Cash' : 'Credit Card'} File`}
                                dataQa={'select-image'}
                            />
                            {(firstFile && firstFile?.name)
                                ? <p className={'ml-3'}>{firstFile?.name}</p> : <></>
                            }
                        </div>
                        <div
                            className='flex flex-row items-center mt-5 mb-4'
                            {...getRootPropsActive()}
                        >
                            <input {...getInputPropsActive()} />
                            <Button
                                icon={<img src='/assets/shared/add-plus.svg' className='w-[30px] object-contains pr-2' />}
                                className={'btn-main !bg-white !py-2 !pr-3 !shadow-none !border-none flex flex-row items-center min-w-[250px]'}
                                label={'Select Bank Transaction File'}
                                dataQa={'select-transaction-file'}
                            />
                            {(secondFile && secondFile?.name)
                                ? <p className={'ml-3'}>{secondFile?.name}</p> : <></>
                            }
                        </div>
                        <div
                            className='flex flex-row items-center mt-5 mb-4'
                            {...getRootPropsOpera()}
                        >
                            <input {...getInputPropsOpera()} />
                            <Button
                                icon={<img src='/assets/shared/add-plus.svg' className='w-[30px] object-contains pr-2' />}
                                className={'btn-main !bg-white !py-2 !pr-3 !shadow-none !border-none flex flex-row items-center min-w-[250px]'}
                                label={'Select Opera File'}
                                dataQa={'select-transaction-file'}
                            />
                            {(thirdFile && thirdFile?.name)
                                ? <p className={'ml-3'}>{thirdFile?.name}</p> : <></>
                            }
                        </div>
                    </div>
                </div>
                {generalError &&
                    <div className='flex flex-row justify-center my-3'>
                        <Error text={generalError} />
                    </div>
                }
                <div className='flex flex-row justify-end mt-4'>
                    <Button
                        label='Submit'
                        secondLoading={submitLoading}
                        className={submitLoading ? 'btn-primary-rounded-less-disable min-w-[150px]' : 'btn-primary-rounded-less min-w-[150px]'}
                        dataQa={'add-asset-save-btn'}
                        onClickButton={onSubmit}
                    />
                </div>
                {response &&
                    <DiscrepancyModal
                        openModal={!!response}
                        data={response}
                        handleCloseModal={onCloseModal}
                    />
                }
            </div>
        </Modal>
    )
}
export default UploadFilesModal;
